// extracted by mini-css-extract-plugin
export default {"user":"user_user__U7iJd","user__label":"user_user__label__icQ34","user__feedback":"user_user__feedback__lvHEm"};